(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    ngModule.service('$Stores', function($firebaseArray, $firebaseObject, $q) {
        var fireRef = firebase.database().ref().child('store');

        return {
            ref: fireRef,
            add: function (obj) {
                return fireRef.push(obj);
            },
            get: function(id) {
                return $firebaseObject(fireRef.child(id));
            },
            getStoreWithPromise: function(id) {
                return $q(function(resolve, reject) {
                    resolve($firebaseObject(fireRef.child(id)))
                });
            },
            all: function() {
                var data = [];

                return $firebaseArray(fireRef);
            }
        };

    });
})();
